// @ts-nocheck

import { useCallback } from "react";
import cn from "classnames";

import { ColumnsProps } from "../Table.props";
import Icon from "../../../brand/Icon";
import { QueryOptions, SortOrder } from "../../Paginate/Paginate.props";

/**
 * @deprecated
 */
function Columns<T>({ headers, handleUpdateRequest, queryOptions, resetTable, testId }: ColumnsProps<T>): JSX.Element {
  const orderByColumns = useCallback(
    (key: string): string | null => {
      let order = null;
      if (queryOptions) {
        if (queryOptions.order_by !== undefined) {
          queryOptions.order_by.map((data) => {
            if (key in data) {
              order = data[key];
            }
          });
        }
      }
      return order;
    },
    [queryOptions],
  );

  const clickHandler = useCallback(
    (key: string) => {
      if (queryOptions) {
        let sortDirection = SortOrder.Asc;
        if (orderByColumns(key) === null || orderByColumns(key) === "asc") {
          sortDirection = SortOrder.Desc;
        }

        const order: { [key: string]: SortOrder } = {};
        order[key] = sortDirection;

        const config: QueryOptions = {
          ...queryOptions,
          page_number: queryOptions.page_number,
          results_per_page: queryOptions.results_per_page,
          order_by: [order],
        };

        resetTable();
        handleUpdateRequest && handleUpdateRequest(config);
      }
    },
    [handleUpdateRequest, queryOptions],
  );

  const orderByIcon: { [key: string]: string } = {
    asc: "arrow-up",
    desc: "arrow-down",
  };

  const colTestId = testId ? testId + "_" : "test__";

  const columns = headers.map(({ key, label, sortable = true }) => {
    const orderBy: string = orderByColumns(key as string) || "asc";

    let headerContent = (
      <div className="table-header">
        <span className="table-header-label" data-testid={`${colTestId}${key}`}>
          {label}
        </span>
        <span className="table-header-icon">
          <Icon name={orderByIcon[orderBy]} size="small" />
        </span>
      </div>
    );

    if (!key || key === "checkbox-select-all" || !sortable || queryOptions?.order_by === undefined) {
      headerContent = (
        <span className="table-header-label" data-testid={`${colTestId}${label}`}>
          {label}
        </span>
      );
    }

    const headerClass = cn(
      {
        "is-sorted": queryOptions?.order_by ? queryOptions.order_by.some((obj) => Object.keys(obj).includes(key as string)) : false,
      },
      {
        "select-all-checkbox-th": key === "checkbox-select-all",
      },
    );

    return (
      <th
        role="button"
        key={key || "action-column"}
        scope="col"
        className={headerClass}
        onClick={() => {
          if (sortable && queryOptions?.order_by !== undefined) {
            clickHandler(key as string);
          }
        }}
      >
        {headerContent}
      </th>
    );
  });

  return <tr>{columns}</tr>;
}

/**
 * @deprecated
 */
export default Columns;
